/* eslint-disable max-lines */
import { css } from 'linaria';

export const pageStyles = css`
	button {
		margin: 0;
		overflow: visible;
		font-weight: 400;
		font-size: 100%;
		font-family: LeroyMerlin, Arial, 'Nimbus Sans L', sans-serif;
		line-height: 1.15;
		text-transform: none;
		background: 0 0;
		border: none;
		cursor: pointer;
	}

	sup {
		position: relative;
		top: -0.5em;
		font-size: 75%;
		line-height: 0;
		vertical-align: baseline;
	}

	h1 {
		margin: 0.67em 0;
		font-size: 2em;
	}

	b {
		font-weight: bolder;
		font-weight: 700;
	}

	img {
		max-width: 100%;
		height: auto;
		border-style: none;
	}

	[type='button'],
	button {
		appearance: button;
	}

	* {
		box-sizing: border-box;
		padding: 0;
		margin: 0;
		outline: 0;
	}

	*,
	::after,
	::before {
		box-sizing: inherit;
	}

	.page-wrapper {
		max-width: 1440px;
		padding-right: 80px;
		padding-left: 80px;
		margin: auto;
	}

	@media (width <= 1023px) {
		.page-wrapper {
			padding-right: 40px;
			padding-left: 40px;
		}
	}

	@media (width <= 639px) {
		.page-wrapper {
			padding-right: 16px;
			padding-left: 16px;
		}
	}

	.cl-green {
		color: var(--control-hover-accent);
	}

	#nav-materials {
		min-height: 6px;
	}

	a {
		text-decoration: none;
		color: var(--control-hover-accent);
		background-color: transparent;
		border-bottom: 1px solid var(--control-hover-accent);
		transition: all 0.2s ease;
	}

	@media (width >= 1024px) {
		a:hover {
			text-decoration: none;
			color: var(--control-hover-accent);
			border-color: var(--control-hover-accent);
		}
	}

	p {
		margin: 0 0 15px;
	}

	h1,
	h2,
	h3,
	h4 {
		margin: 30px 0;
		font-weight: 700;
		font-size: 2.25rem;
		line-height: 1.3;
		color: #333;
	}

	h1,
	h1:first-child {
		margin-top: 0;
	}

	@media (width <= 1023px) {
		h1 {
			font-size: 1.75rem;
		}
	}

	@media (width <= 767px) {
		h1 {
			font-size: 1.125rem;
		}
	}

	h2 {
		font-size: 1.75rem;
	}

	@media (width <= 1023px) {
		h2 {
			font-size: 1.5rem;
		}
	}

	@media (width <= 767px) {
		h2 {
			font-size: 1rem;
		}
	}

	h3 {
		font-size: 1.5rem;
	}

	@media (width <= 1023px) {
		h3 {
			font-size: 1.25rem;
		}
	}

	@media (width <= 767px) {
		h3 {
			font-size: 0.9375rem;
		}
	}

	h4 {
		font-size: 1.25rem;
	}

	@media (width <= 1023px) {
		h4 {
			font-size: 1.125rem;
		}
	}

	@media (width <= 767px) {
		h4 {
			font-size: 0.875rem;
		}
	}

	ol,
	ol li,
	ul,
	ul li {
		margin-bottom: 15px;
	}

	ol li {
		list-style: decimal inside;
	}

	ul li {
		list-style: disc inside;
	}

	table {
		position: relative;
	}

	table th {
		font-weight: 700;
	}

	.services-table {
		width: 100%;
		margin-top: 15px;
		margin-bottom: 30px;
		background-color: #fff;
		border-collapse: collapse;
		box-shadow: 0 10px 22px 0 rgb(72 72 72 / 5%);
	}

	.services {
		padding-top: 17px;
		padding-bottom: 127px;
		background-color: #fff;
	}

	@media (width <= 1199px) {
		.services {
			padding-top: 29px;
			padding-bottom: 94px;
		}
	}

	.services__title {
		margin-bottom: 33px;
		font-size: 1.8125rem;
		line-height: 1.45;
		text-transform: uppercase;
	}

	@media (width <= 1023px) {
		.services {
			padding-top: 27px;
			padding-bottom: 60px;
		}

		.services__title {
			font-size: 2.1875rem;
			line-height: 1.26;
		}
	}

	@media (width <= 767px) {
		.services {
			padding-top: 19px;
			padding-bottom: 80px;
		}

		.services__title {
			margin-bottom: 23px;
			font-size: 1.5rem;
			line-height: 1.21;
		}

		.services-table {
			display: block;
			overflow-x: auto;
		}
	}

	.services__title_medium {
		font-weight: 600;
		font-size: 1.75rem;
		letter-spacing: 0.3px;
	}

	@media (width <= 1023px) {
		.services__title_medium {
			margin-bottom: 29px;
			font-size: 1.125rem;
			line-height: 1.39;
			letter-spacing: normal;
			text-transform: none;
		}
	}

	.services-table tbody tr {
		border: 1px solid #ddd;
	}

	.services-table tbody tr td {
		padding: 16px 10px;
		font-size: 13px;
		font-family: inherit;
		text-align: left;
		color: #5b5b5b;
		border: 1px solid #ddd;
	}

	.services-table tbody tr td:first-child {
		padding-left: 28px;
	}

	.services-table tbody tr td:last-child {
		padding-right: 28px;
	}

	.services-table tbody tr th {
		padding: 23px 10px;
		font-weight: 700;
		font-size: 13px;
		text-align: left;
		color: #adadad;
		border-right: 1px solid #ddd;
		border-bottom: 3px solid var(--control-hover-accent);
		border-left: 1px solid #ddd;
	}

	.services-table tbody tr th:first-child {
		padding-left: 28px;
	}

	.services-table tbody tr th:last-child {
		padding-right: 28px;
	}

	.services__content {
		padding-top: 32px;
		padding-left: 32px;
	}

	@media (width <= 1023px) {
		.services__content {
			max-width: 100%;
			padding-top: 0;
			padding-left: 0;
			font-size: 0.75rem;
		}
	}

	.services-title {
		margin-bottom: 32px;
		font-weight: 700;
		font-size: 1.5625rem;
		line-height: 1.3;
		text-transform: uppercase;
	}

	@media (width <= 1023px) {
		.services-title {
			margin-bottom: 24px;
			font-size: 1.125rem;
			text-transform: none;
		}
	}

	.services__content ul li {
		margin-bottom: 0;
	}

	.services-cols::after {
		display: block;
		clear: both;
		content: '';
	}

	.services-cols__item {
		float: left;
	}

	.services-cols__item:first-child {
		width: 207px;
		margin-right: 43px;
	}

	.services-cols__item:last-child {
		width: calc(100% - 250px);
	}

	@media (width <= 1023px) {
		.services-cols__item:first-child {
			/* display: none; */
		}

		.services-cols__item:last-child {
			width: 100%;
		}
	}

	.advice__back-btn {
		position: relative;
		top: 1px;
		display: inline-block;
		margin: 25px 0;
		font-size: 16px;
		line-height: 22px;
	}

	@media (width <= 479px) {
		.advice__back-btn {
			margin-bottom: 8px;
		}
	}

	.advice__back-btn,
	.advice__back-btn:hover {
		border-bottom: none;
	}

	.advice__back-btn::before {
		width: 11px;
		height: 6px;
		margin-right: 4px;
		content: url("https://s.leroymerlin.kz/assets/build/build1616/img/svg/arrow-back-advice.svg?cbh=4d87f5da288935e4d44c0df548469d76");
		background-repeat: no-repeat;
		background-position: 50% 50%;
		background-size: cover;
	}

	.advice__back-btn--services {
		margin-top: 0;
		margin-bottom: 25px;
	}

	.new-services .new-services-cols__item:first-child {
		min-width: 278px;
		margin-top: 32px;
		margin-right: 0;
		background-color: #fff;
	}

	.new-services .new-services-cols__item:last-child {
		width: 100%;
		max-width: 100%;
	}

	@media (width <= 1023px) {
		.new-services .new-services-cols__item:last-child {
			max-width: 100%;
			padding: 32px 0;
		}
	}

	@media (width <= 767px) {
		.new-services .new-services-cols__item:last-child {
			padding: 20px 0;
		}
	}

	.icon {
		position: relative;
		display: inline-block;
		font-size: 0;
		line-height: 0;
		text-align: center;
		vertical-align: middle;
		transition: color 0.2s ease, background-color 0.2s ease, border-color 0.2s ease,
			opacity 0.2s ease;
	}

	.icon-search-lg {
		width: 24px;
		height: 24px;
		background-image: url("https://s.leroymerlin.kz/assets/build/build1616/img/svg/search_lg.svg?cbh=ace0fab22079ecac5f28c065580d0a56");
		background-repeat: no-repeat;
		background-position: 50% 50%;
	}

	button:disabled {
		cursor: default;
	}

	.services-card {
		display: block;
		padding: 26px;
		margin: 32px 0 40px;
		background-color: #fafafa;
	}

	@media (width <= 479px) {
		.services-card {
			margin-bottom: 24px;
		}
	}

	.zoom-image__container {
		position: relative;
		display: inline-block;
	}

	.zoom-image__btn {
		position: absolute;
		top: 6px;
		right: 6px;
		z-index: 9;
		padding: 6px;
		background-color: rgb(255 255 255 / 20%);
		border: 1px solid rgb(255 255 255 / 20%);
		border-radius: 6px;
	}

	.zoom-image__btn:hover {
		background-color: rgb(255 255 255 / 40%);
		border: 1px solid #fff;
	}
`;
